// extracted by mini-css-extract-plugin
module.exports = {"root":"_2s7oV","collapsed":"_3F-0u"};